Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    thumbnailSizeSmall: 48,
    thumbnailSizeMedium: 64,
    thumbnailSizeLarge: 80,
    thumbnailBorderWidth: 1,
    thumbnailBorderCircularRadiusSmall: 24,
    thumbnailBorderCircularRadiusMedium: 32,
    thumbnailBorderCircularRadiusLarge: 40,
    thumbnailBorderSquareRadius: 4
  }
};